import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/node_modules/lucide-react/dist/esm/Icon.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/app/[locale]/chat/ChatExperience.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/web-app/frontend/src/components/AuthLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/FaqList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/web-app/frontend/src/components/SharedHeader.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/web-app/frontend/src/lib/localized-link.tsx");
